// MobileUpload.jsx
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const MobileUpload = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadData, setUploadData] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Parse upload data from URL parameters
    const urlParams = new URLSearchParams(location.search);
    const dataParam = urlParams.get('data');
    if (dataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(dataParam));
        setUploadData(parsedData);
      } catch (error) {
        console.error('Error parsing upload data:', error);
      }
    }
  }, [location]);

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file || !uploadData) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', uploadData.sessionId);
    formData.append('employeeId', uploadData.employeeId);
    formData.append('documentType', uploadData.documentType);

    try {
      setUploading(true);
      const response = await axios.post(
        `${uploadData.baseUrl}/api/documents/mobile-upload`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (response.data.success) {
        alert('File uploaded successfully!');
        // Close the window or redirect
        window.close();
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mobile-upload-container">
      <div className="mobile-upload-header">
        <h1>📱 Document Upload</h1>
        <p>Upload document for: {uploadData?.documentType}</p>
      </div>

      <div className="mobile-upload-form">
        <div className="file-input-section">
          <input
            type="file"
            accept="image/*,application/pdf"
            onChange={handleFileSelect}
            className="mobile-file-input"
            capture="environment"
          />
          <button 
            onClick={() => document.querySelector('.mobile-file-input').click()}
            className="capture-button"
          >
            {file ? `✅ ${file.name}` : '📷 Take Photo or Choose File'}
          </button>
        </div>

        {file && (
          <div className="preview-section">
            <p>File selected: {file.name}</p>
            {file.type.startsWith('image/') && (
              <img 
                src={URL.createObjectURL(file)} 
                alt="Preview" 
                className="image-preview"
              />
            )}
          </div>
        )}

        <button 
          onClick={handleUpload}
          disabled={!file || uploading}
          className="upload-btn"
        >
          {uploading ? 'Uploading...' : 'Upload Document'}
        </button>
      </div>
    </div>
  );
};

export default MobileUpload;